import { Skeleton } from '../../../shadcn/components/skeleton';

function InboxSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <Skeleton className="h-5 w-40 px-4 mt-4 md:mt-0" />

      <div className="flex flex-col items-center gap-1.5">
        {Array.from({ length: 4 }).map((_, index) => (
          <div key={index} className="w-full rounded-lg p-4 shadow-sm border border-gray-100">
            <div className="flex items-start gap-4">
              <Skeleton className="w-12 h-12 rounded-lg flex-shrink-0" />

              <div className="flex-1 min-w-0">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <Skeleton className="h-5 w-3/4 mb-2" />
                    {(index === 0 || index === 2) && <Skeleton className="h-4 w-full" />}
                  </div>

                  <Skeleton className="h-4 w-16 flex-shrink-0" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export { InboxSkeleton };
